export const contactConfig = {
    phone: '07 43 59 54 51',
    phone2: '06 95 35 11 59',
    email: 'contact@akte-immobilier.com',
    address: '4 rue des Bonnes Gens 68100 Mulhouse',
    mapUrl: 'https://maps.google.com/?q=4+rue+des+Bonnes+Gens+68100+MULHOUSE',
    legalMentionsText: 'Mentions légales'
};
